import axios from "axios";

export const state = {
    products: [],
};

export const getters = {
    products: state => state.products,
};

export const mutations = {
    setProducts(state, newValue) {
        state.products = newValue
    },
};

export const actions = {
    async fetchProducts({ commit }) {
        await axios.get('/products').then(res => {
            commit('setProducts', res.data.products)
        })
    },
};
